import { z } from "zod";
import { dataSchema } from "./competencia";
import { TIPOS_FINANCEIROS, FORMAS_DE_PAGAMENTO } from "./lancamento";

const transacao = z.object({
  idNoBanco: z.string().min(1).max(200),
  data: dataSchema,
  valorCents: z.number().int().positive(),
  tipo: z.enum(TIPOS_FINANCEIROS),
  descricao: z.string().min(1).max(200),
});

/** As linhas lidas do arquivo, para o servidor dizer o que já existe e sugerir o resto. */
export const extratoPrepararSchema = z.object({ transacoes: z.array(transacao).min(1).max(2000) });

/** O que fazer com cada linha: criar, dar baixa numa conta, receber uma cobrança, marcar como já lançada ou ignorar. */
export const acaoDaLinhaSchema = z.discriminatedUnion("acao", [
  z.object({ acao: z.literal("novo"), categoriaId: z.string().min(1), partnerId: z.string().min(1).nullable() }),
  z.object({ acao: z.literal("baixarConta"), lancamentoId: z.string().min(1) }),
  z.object({ acao: z.literal("receberCobranca"), extratoId: z.string().min(1) }),
  z.object({ acao: z.literal("jaLancado"), lancamentoId: z.string().min(1) }),
]);
export type AcaoDaLinha = z.infer<typeof acaoDaLinhaSchema>;

export const extratoIniciarSchema = z.object({ arquivo: z.string().min(1).max(200), conta: z.string().max(100).nullable() });

export const extratoLoteSchema = z.object({
  importacaoId: z.string().min(1),
  itens: z.array(transacao.extend({ forma: z.enum(FORMAS_DE_PAGAMENTO).nullable(), destino: acaoDaLinhaSchema })).min(1).max(500),
  /** A categoria escolhida por favorecido, para vir pronta na próxima importação. */
  regras: z.array(z.object({ tipo: z.enum(TIPOS_FINANCEIROS), chave: z.string().min(1).max(200), categoriaId: z.string().min(1), partnerId: z.string().min(1).nullable() })).max(500),
});
export type ExtratoLoteInput = z.infer<typeof extratoLoteSchema>;
